import React from "react";
import { Page } from "../../activities/AppPage";
import { API } from "../../API";
import useAgencies from "../../hooks/useAgencies";
import useTrainingCenterState from "../../hooks/useTrainingCenterState";
import { isLoading } from "../../Loading";
import { TrainingCenterBundleDueDateId } from "../../messages";
import { STRINGS } from "../../strings";
import { AppState } from "../../system/AppState";
import { translate } from "../../translate";
import LoadingScaffold from "../LoadingScaffold";
import TrainingCenterTabs from "../Main/components/TrainingCenterTabs";
import ScaffoldTitle from "../Scaffold/components/ScaffoldTitle";
import Scaffold from "../Scaffold/Scaffold";
import TrainingCenterBundlesList, {
  TrainingCenterBundlesTab,
} from "../TrainingCenterBundles/components/TrainingCenterBundlesList";
import { TrainingCenterLanguagePreference } from "./TrainingCenterLanguageLookup";
import { transformAgencies } from "./TrainingCenterUtils";

type Props = {
  api: API;
  appState: AppState;
  initialTab?: TrainingCenterBundlesTab;
  languagePreference: TrainingCenterLanguagePreference;
  onClickGoBack: () => void;
  onRequestNavigate: (page: Page) => void;
};

export default function TrainingCenterActivity(props: Props) {
  const [activeTab, setActiveTab] = React.useState<TrainingCenterBundlesTab>(
    props.initialTab ?? "Required"
  );

  const agencies = useAgencies(props.appState);

  const trainingCenterState = useTrainingCenterState(props.appState);

  const handleClickBundle = (bundleDueDateId: TrainingCenterBundleDueDateId) => {
    props.onRequestNavigate({
      type: "TrainingCenterBundle",
      bundleDueDateId: bundleDueDateId,
    });
  };

  if (isLoading(agencies) || isLoading(trainingCenterState)) {
    return (
      <LoadingScaffold title={translate(STRINGS.INSERVICES)} onClickGoBack={props.onClickGoBack} />
    );
  }

  return (
    <Scaffold
      title={<ScaffoldTitle label={translate(STRINGS.INSERVICES)} />}
      extraHeader={<TrainingCenterTabs activeTab={activeTab} onClick={setActiveTab} />}
      onClickGoBack={props.onClickGoBack}
    >
      <TrainingCenterBundlesList
        activeTab={activeTab}
        languagePreference={props.languagePreference}
        agencies={transformAgencies(agencies)}
        bundles={trainingCenterState.bundles.bundles}
        onClickBundle={handleClickBundle}
      />
    </Scaffold>
  );
}
